import React from 'react'
import Manager from '../../public/components/Manager'
import OrderingDetail from './OrderingDetail'
import SelectDateDiv from './SelectDateDiv'

Ext.require('Ext.Toast')

const config = {
    buttons: [
        {
            text: '导出...', handler: ({ showDetail, refreshPage }) =>
                Tyan.pubForm.showDialog('月薪申请', props => <SelectDateDiv {...props} onSave={refreshPage} />)
        },

    ],
    columns: [
        { _date: '日期', field: 'OrderDate', minWidth: 250, filter: true, align: 'left' },
        { _int: '订餐人数', field: 'OrderCount', minWidth: 150, },
        { _int: '不订餐人数', field: 'NoOrderConut', minWidth: 150, },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('订餐明细', props => <OrderingDetail {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />